import { call, put, takeLatest } from 'redux-saga/effects';
import {
  deletePartner,
  getPartnerDetail,
  getPartnerList,
} from '../../api/constlink';
import { Enterprise } from '../auth';
import {
  deletePartnerAsync,
  DELETE_PARTNER,
  getPartnerDetailAsync,
  getPartnerListAsync,
  GET_PARTNER_DETAIL,
  GET_PARTNER_LIST,
} from './actions';

function* getPartnerListSaga(
  action: ReturnType<typeof getPartnerListAsync.request>,
) {
  try {
    const partners: Enterprise[] = yield call(getPartnerList, action.payload);
    yield put(getPartnerListAsync.success(partners));
  } catch (e: any) {
    yield put(getPartnerListAsync.failure(e));
  }
}

function* getPartnerDetailSaga(
  action: ReturnType<typeof getPartnerDetailAsync.request>,
) {
  try {
    const partner: Enterprise = yield call(getPartnerDetail, action.payload);
    yield put(getPartnerDetailAsync.success(partner));
  } catch (e: any) {
    yield put(getPartnerDetailAsync.failure(e));
  }
}

function* deletePartnerSaga(
  action: ReturnType<typeof deletePartnerAsync.request>,
) {
  try {
    const partnerId: number = yield call(deletePartner, action.payload);
    yield put(deletePartnerAsync.success(partnerId));
  } catch (e: any) {
    yield put(deletePartnerAsync.failure(e));
  }
}

/*
function* createPartnerSaga(
  action: ReturnType<typeof createPartnerAsync.request>,
) {
  try {
    const billingPeriod: Partner = yield call(createPartner, action.payload);
    yield put(createPartnerAsync.success(billingPeriod));
  } catch (e: any) {
    yield put(createPartnerAsync.failure(e));
  }
}

function* updatePartnerSaga(
  action: ReturnType<typeof updatePartnerAsync.request>,
) {
  try {
    const billingPeriod: Partner = yield call(updatePartner, action.payload);
    yield put(updatePartnerAsync.success(billingPeriod));
  } catch (e: any) {
    yield put(updatePartnerAsync.failure(e));
  }
}
*/

export function* partnersSaga() {
  yield takeLatest(GET_PARTNER_LIST, getPartnerListSaga);
  yield takeLatest(GET_PARTNER_DETAIL, getPartnerDetailSaga);
  yield takeLatest(DELETE_PARTNER, deletePartnerSaga);
  /*
  yield takeLatest(CREATE_PARTNER, createPartnerSaga);
  yield takeLatest(UPDATE_PARTNER, updatePartnerSaga);
  
  */
}
